module.exports = new __parcel__URL__("security-permissions-darkmode.3c5db0bb.svg").toString();